import { getLimitConfiguration } from './get-limit-configuration';
import { MakeCreateLimitOperation } from './types';

export const makeCreateLimitOperation: MakeCreateLimitOperation = (
  offerId,
  values,
  limitType,
  limitScope,
) => ({
  name: 'limitCreate',
  variables: {
    input: {
      offerId,
      configuration: getLimitConfiguration(limitScope, values, limitType),
    },
  },
});
